export const isLiBang = () => {
    // // 立邦跟立时 目前的 mainId 是相同的
    // let mainIds = ["de7a4b88bd234b9c8bf5469db6af4982"]
    // let mainId = sessionStorage.setItem("mainIds", mainIds)
    // return mainIds.includes(mainId)
    return process.env.VUE_APP_SOURCE === 'lishi'
}